<template>
    <TheService v-if="service" :service="service" />
</template>

<script>
import Configure from "./../../mixins/configure";
import ServiceRepository from "./../../mixins/service-repository";
import TheService from "../services/TheService";
import Service from "../../models/service";
export default {
    beforeRouteUpdate (to, from, next) {
        this.getService(to.params.service);
        next()
    },
    created() {
        if (this.$route.params.service == undefined) {
            this.$router.push({ path: "/" });
        }
        this.getService(this.$route.params.service);
    },
    components: {
        TheService
    },
    data() {
        return {
            service: null
        };
    },
    mixins: [Configure, ServiceRepository],
    methods: {
        getService(id) {
            this.$store.commit('toggleLoading')

            this.getUserService(id)
                .then((item) => {
                    this.service = new Service(item);
                    this.$store.commit("singleMusicPageName", {name: this.service.name})
                })
                .catch((e) => {
                    console.error(e)
                    this.$router.push({ path: "/" });
                })
                .finally(() => {
                    this.$store.commit('toggleLoading')
                });
        }
    }
};
</script>
